import { Middleware } from "@reduxjs/toolkit";

import { saveToStorage } from "../../common/utils/functions/localStorage";

export const complexOrderCartCacheMiddleware: Middleware =
  (store) => (next) => (action: any) => {
    const result = next(action);

    if (action.type?.startsWith?.("complexOrderCart/")) {
      const state = store.getState().complexOrderCart;
      try {
        saveToStorage("complexOrderCart", state);
      } catch {
        // ignore
      }
    }

    return result;
  };
